module.exports = __webpack_public_path__ + "static/media/filter.a49936f9.svg";